import React, { useEffect, useState } from "react";
import styles from "./tripDetails.module.css"; // if you're using external CSS
import { get, post } from "../../../../components/api";
import moment from "moment";
import TripMapComponent from "../../../../components/Map_Trip";
import Drawer from "../../../../components/Drawer";
import { useNavigate, useLocation } from "react-router-dom";
import GoogleMapsLoader from "../../../../components/GoogleMapsLoader";
// import TripMapComponent from "../../../../components/Map_Trip";

const SpeechBubble = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tripId = location.state.id;
  const [data, setData] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [timeFilter, setTimeFilter] = useState("today");
  const [routeHistoryData, setRouteHistoryData] = useState([]);
  const [totalTime, setTotalTime] = useState([]);
  const [stopTime, setStopTime] = useState([]);

  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
    // setRouteType("route-history");
    if (drawerOpen) {
      setTimeFilter("today");
    }
  };
  const fetchTripData = async () => {
    const response = await get(`admin/tms/trip-details/${tripId}`);
    if (response.status == 200) {
      setData(response.data[0]);
    } else {
      setData([]);
    }
  };
  useEffect(() => {
    fetchTripData();
  }, []);

  // timeFilter,dateRange

  const fetchVehicleHistoryData = async () => {
    console.log("functionCall");
    try {
      let d = {
        vehicleNo: data?.vehicleInfo?.vehicleNo,
        timeFilter: "range",
        startDate: data?.originReportingTime,
        endDate: data?.routeEndTime,
        // startDate: "2025-05-01T14:21:00.000Z",
        // endDate: "2025-05-03T14:21:00.000Z",
      };
      // if (dateRange !== null) {
      //   data.startDate = dateRange.startDate;
      //   data.endDate = dateRange.endDate;
      // }
      const getVehicleHistoryData = await post("/admin/get-route-history", d);
      if (getVehicleHistoryData.status === 200) {
        const stops = [];
        // Use Promise.all() to concurrently process each object
        if (getVehicleHistoryData.data.data.length > 0) {
          getVehicleHistoryData.data.data.forEach((stop) => {
            if (stop.status == "stopped") {
              stops.push(stop);
            }
          });
        }
        // let locationsArr = getVehicleHistoryData.data.locations;
        // const polylinePath = locationsArr.map((item) => ({
        //   lat: item.coordinates[0],
        //   lng: item.coordinates[1],
        //   speed: item.speed,
        //   angle: item.angle,
        // }));
        // const locations = polylinePath.reverse();
        const historyData = getVehicleHistoryData.data;
        setRouteHistoryData(historyData.data);
        // setLocationData(historyData.locationData);
        // setStopsData(historyData.stops);
        // setIsHistoryLoading(historyData.isHistoryLoading);
        setTotalTime(historyData?.totalRunTime);
        setStopTime(historyData?.stopTime);
        // return {
        //   routeHistoryData: getVehicleHistoryData.data.data,
        //   stops: stops,
        //   totalRunTime: getVehicleHistoryData.data.totalRunTime,
        //   stopTime: getVehicleHistoryData.data.stopTime,
        //   locationData: locations,
        //   isHistoryLoading: false,
        // };
      }

      // return {
      //   routeHistoryData: [],
      //   locationData: [],
      //   stops: [],
      //   totalRunTime: "0 kmh (0h:0m)",
      //   stopTime: "0 kmh (0h:0m)",
      //   isHistoryLoading: false,
      //   errorMessage: "Unable to fetch the route history. Please try again.",
      // };
    } catch (error) {
      console.log("error", error);
      return {
        routeHistoryData: [],
        locationData: [],
        stops: [],
        isHistoryLoading: false,
        errorMessage: "Unable to fetch the route history. Please try again.",
      };
    }
  };

  useEffect(() => {
    fetchVehicleHistoryData();
  }, [data]);

  return (
    <GoogleMapsLoader>
      <div className={styles.MainDiv}>
        {drawerOpen && (
          <Drawer
            show={drawerOpen}
            closeDrawer={toggleDrawer}
            data={routeHistoryData}
            timeFilter={timeFilter}
            historyDataFilter={null}
            isLoading={false}
            historyDataCustomRange={null}
            totalRunTime={totalTime}
            stopTime={stopTime}
          />
        )}
        <div className={styles.Heading}>Trip Details</div>
        <div className="row">
          <div className="col-md-12 col-lg-5 col-xs-12">
            <div className={styles.ContentDiv}>
              <div className="col-md-12 col-lg-12 col-xs-12 mb-3 d-flex align-items-center gap-2">
                <svg
                  width="10"
                  height="17"
                  viewBox="0 0 12 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => navigate("/tms/trip-dashboard")}
                  style={{ cursor: "pointer" }}
                >
                  <path
                    d="M10.5 2L3 9.5L10.5 17"
                    stroke="#7498A6"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>

                <p className={styles.Subheading}>Contact Person</p>
              </div>
              <hr className={`${styles.divider} mb-3`} />
              <div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Vehicle Number</p>
                  <p className={styles.infoValue}>
                    {data?.vehicleInfo?.vehicleNo}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Route Name</p>
                  <p className={styles.infoValue}>{data?.tripName}</p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Schedule distance</p>
                  <p className={styles.infoValue}>
                    {data?.routeData?.routePoints[0]?.distance} KM
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Reporting Time</p>
                  <p className={styles.infoValue}>
                    {moment(data?.originReportingTime).format(
                      "DD/MM/YYYY HH:mm"
                    )}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Loading Finish Time</p>
                  <p className={styles.infoValue}>
                    {moment(data?.originReportingTime)
                      .add(data?.loadingTime, "hours")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Route Start Time</p>
                  <p className={styles.infoValue}>
                    {moment(data?.routeStartTime).format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Destination Reporting TIme</p>
                  <p className={styles.infoValue}>
                    {moment(data?.destinationReportingTime).format(
                      "DD/MM/YYYY HH:mm"
                    )}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Unloading Finish Time</p>
                  <p className={styles.infoValue}>
                    {moment(data?.destinationReportingTime)
                      .add(data?.unloadingTime, "hours")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Buffer Time</p>
                  <p className={styles.infoValue}>{data.TripBuffer}h</p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Estimated Route End Time</p>
                  <p className={styles.infoValue}>
                    {moment(data?.routeEndTime)
                      .add(data.TripBuffer, "hours")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Total Expense</p>
                  <p className={styles.infoValue}>
                    INR {Math.round(data?.totalBudget)}
                  </p>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-xs-12 mb-3 mt-3">
                <p className={styles.Subheading}>Contact Person</p>
                <hr className={styles.divider} />
              </div>
              <div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Route</p>
                  <p className={styles.infoValue}>
                    {data.locationData
                      ? Math.round(
                          ((data?.locationData[0]?.distance -
                            data?.locationData[data?.locationData?.length - 1]
                              ?.distance) *
                            100) /
                            data?.routeData?.routePoints[0]?.distance
                        )
                      : 0}{" "}
                    %
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>Cover Distance</p>
                  <p className={styles.infoValue}>
                    {data?.locationData
                      ? data?.locationData[0]?.distance -
                        data?.locationData[data.locationData.length - 1]
                          ?.distance
                      : 0}{" "}
                    KM
                  </p>
                </div>
                <div className={styles.infoDiv}>
                  <p className={styles.infolabel}>ETA</p>
                  <p className={styles.infoValue}>
                    {moment(data?.routeEndTime).format("DD/MM/YYYY HH:MM")}
                  </p>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-xs-12 mb-3 mt-3">
                <p className={styles.Subheading}>Current Status</p>
                <hr className={styles.divider} />
              </div>
              <div className={`row mt-4`}>
                <div className={styles.topBubble}>
                  <div
                    className={styles.location_bubble}
                    style={{ marginBottom: "40px" }}
                  >
                    {data?.routeData?.routePoints[0]?.city},
                    {data?.routeData?.routePoints[0]?.state}
                    <div className={styles.bottomTip}></div>
                  </div>
                </div>
                {data?.actualOriginReportingTime && (
                  <>
                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.location_bubble}>
                        {data?.routeData?.routePoints[0]?.city},
                        {data?.routeData?.routePoints[0]?.state}
                        <div className={styles.sideTip}></div>
                      </div>
                      <div className={styles.Arrival}>
                        <p className={styles.historyMainText}>Arrival Time</p>
                        <p className={styles.historySecondText}>
                          {moment(data?.actualOriginReportingTime).format(
                            "DD/MM/YYYY"
                          )}
                        </p>
                        <p className={styles.historyThirdText}>
                          {moment(data?.actualOriginReportingTime).format(
                            "hh:MM A"
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-2 col-lg-2 col-xs-2">
                      <svg
                        width="28"
                        height="195"
                        viewBox="0 0 28 195"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 14L14 195"
                          stroke="#668FA3"
                          strokeWidth="2"
                        />
                        <circle cx="14" cy="14" r="10" fill="#668FA3" />
                        <circle
                          cx="14"
                          cy="14"
                          r="13.4815"
                          stroke="#81A9BD"
                          strokeWidth="1.03704"
                        />
                      </svg>
                    </div>
                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.wayPoint}>
                        <p className={styles.wayPointText}>
                          Reached To Destination
                        </p>
                      </div>
                      <div className={styles.Departure}>
                        <p className={styles.historyMainText}>
                          Waiting To Load
                        </p>
                        <p className={styles.historySecondText}>
                          {data?.actualLoadingStartTime
                            ? moment(data?.actualLoadingStartTime).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </p>
                        <p className={styles.historyThirdText}>
                          {data?.actualLoadingStartTime
                            ? moment(data?.actualLoadingStartTime).format(
                                "hh:mm A"
                              )
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </>
                )}
                {/* first is over */}
                {data?.actualLoadingStartTime && (
                  <>
                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.location_bubble}>
                        {data?.routeData?.routePoints[0]?.city},
                        {data?.routeData?.routePoints[0]?.state}
                        <div className={styles.sideTip}></div>
                      </div>
                      <div className={styles.Arrival}>
                        <p className={styles.historyMainText}>Loading Start</p>
                        <p className={styles.historySecondText}>
                          {moment(data?.actualLoadingStartTime).format(
                            "DD/MM/YYYY"
                          )}
                        </p>
                        <p className={styles.historyThirdText}>
                          {moment(data?.actualLoadingStartTime).format(
                            "hh:mm A"
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-2 col-lg-2 col-xs-2">
                      <svg
                        width="28"
                        height="195"
                        viewBox="0 0 28 195"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 14L14 195"
                          stroke="#668FA3"
                          strokeWidth="2"
                        />
                        <circle cx="14" cy="14" r="10" fill="#668FA3" />
                        <circle
                          cx="14"
                          cy="14"
                          r="13.4815"
                          stroke="#81A9BD"
                          strokeWidth="1.03704"
                        />
                      </svg>
                    </div>

                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.wayPoint}>
                        <p className={styles.wayPointText}>Loading Duration</p>
                      </div>
                      <div className={styles.Departure}>
                        <p className={styles.historyMainText}>
                          Loading End Time
                        </p>
                        <p className={styles.historySecondText}>
                          {data?.actualLoadingEndTime
                            ? moment(data?.actualLoadingEndTime).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </p>
                        <p className={styles.historyThirdText}>
                          {data?.actualLoadingEndTime
                            ? moment(data?.actualLoadingEndTime).format(
                                "hh:mm A"
                              )
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                {/* second is over */}
                {data?.actualrouteStartTime && (
                  <>
                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.location_bubble}>
                        {data?.routeData?.routePoints[0]?.city},
                        {data?.routeData?.routePoints[0]?.state}
                        <div className={styles.sideTip}></div>
                      </div>
                      <div className={styles.Arrival}>
                        <p className={styles.historyMainText}>Trip Start</p>
                        <p className={styles.historySecondText}>
                          {moment(data.actualrouteStartTime).format(
                            "DD/MM/YYYY"
                          )}
                        </p>
                        <p className={styles.historyThirdText}>
                          {moment(data.actualrouteStartTime).format("hh:mm A")}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-2 col-lg-2 col-xs-2">
                      <svg
                        width="28"
                        height="195"
                        viewBox="0 0 28 195"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 14L14 195"
                          stroke="#668FA3"
                          strokeWidth="2"
                        />
                        <circle cx="14" cy="14" r="10" fill="#668FA3" />
                        <circle
                          cx="14"
                          cy="14"
                          r="13.4815"
                          stroke="#81A9BD"
                          strokeWidth="1.03704"
                        />
                      </svg>
                    </div>

                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.wayPoint}>
                        <p className={styles.wayPointText}>In Transit</p>
                      </div>
                      <div className={styles.Departure}>
                        <p className={styles.historyMainText}>
                          Destination Reach Time
                        </p>
                        <p className={styles.historySecondText}>
                          {data?.actualDestinationReportingTime
                            ? moment(
                                data?.actualDestinationReportingTime
                              ).format("DD/MM/YYYY")
                            : "-"}
                        </p>
                        <p className={styles.historyThirdText}>
                          {data?.actualDestinationReportingTime
                            ? moment(
                                data?.actualDestinationReportingTime
                              ).format("hh:mm A")
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </>
                )}
                {data?.actualUnloadingStartTime && (
                  <>
                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.location_bubble}>
                        {data?.routeData?.routePoints[1]?.city},
                        {data?.routeData?.routePoints[1]?.state}
                        <div className={styles.sideTip}></div>
                      </div>
                      <div className={styles.Arrival}>
                        <p className={styles.historyMainText}>
                          Unloading Start
                        </p>
                        <p className={styles.historySecondText}>
                          {moment(data?.actualUnloadingStartTime).format(
                            "DD/MM/YYYY"
                          )}
                        </p>
                        <p className={styles.historyThirdText}>
                          {moment(data?.actualUnloadingStartTime).format(
                            "hh:mm A"
                          )}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-2 col-lg-2 col-xs-2">
                      <svg
                        width="28"
                        height="195"
                        viewBox="0 0 28 195"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14 14L14 195"
                          stroke="#668FA3"
                          strokeWidth="2"
                        />
                        <circle cx="14" cy="14" r="10" fill="#668FA3" />
                        <circle
                          cx="14"
                          cy="14"
                          r="13.4815"
                          stroke="#81A9BD"
                          strokeWidth="1.03704"
                        />
                      </svg>
                    </div>

                    <div className="col-md-5 col-lg-5 col-xs-5">
                      <div className={styles.wayPoint}>
                        <p className={styles.wayPointText}>
                          Unloading Duration
                        </p>
                      </div>
                      <div className={styles.Departure}>
                        <p className={styles.historyMainText}>Trip End Time</p>
                        <p className={styles.historySecondText}>
                          {data?.actualRouteEndTime
                            ? moment(data?.actualRouteEndTime).format(
                                "DD/MM/YYYY"
                              )
                            : "-"}
                        </p>
                        <p className={styles.historyThirdText}>
                          {data?.actualRouteEndTime
                            ? moment(data?.actualRouteEndTime).format("hh:mm A")
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="14" cy="14" r="10" fill="#668FA3" />
                  <circle
                    cx="14"
                    cy="14"
                    r="13.4815"
                    stroke="#81A9BD"
                    strokeWidth="1.03704"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-7 col-xs-12">
            <div style={{ borderRadius: "12px", overflow: "hidden" }}>
              <TripMapComponent locationsData={data?.locationData || []} />
            </div>
            <div className="d-flex item-center justify-content-end mt-2">
              <button
                className={styles.route_button}
                onClick={() => setDrawerOpen(!drawerOpen)}
              >
                Route History
              </button>
            </div>
          </div>
        </div>
      </div>
    </GoogleMapsLoader>
  );
};

export default SpeechBubble;
